import React, { useCallback, useMemo, useState } from "react";
import { Button, Card, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import wordpress from "../../../assets/img/brands/wordpress.svg";
import { useTranslation } from "../../../hooks/useLocalization";

import useAnalytics from "../../../hooks/useAnalytics";

const BotNewCard = ({ handlers }) => {
  const { t } = useTranslation();
  const { onCreate, onWordpress } = handlers || {};
  const { CONSOLE_EVENTS } = useAnalytics();
  const hover = useHoverState();
  const className = useMemo(
    () =>
      `text-secondary p-3 ${Object.keys(handlers).length > 5 ? "ps-2 pe-2" : ""
      }`,
    [handlers]
  );
  return (
    <Card
      className="flex-fill text-center bot-card"
      {...hover.body}
      onClick={async () => {
        onCreate();
        window.gtag('event', "bots_new_bot")
        await CONSOLE_EVENTS.EV_CreateBot.send({})
      }}
    >
      <Card.Body className="pb-0 bot-card-text">
        <div className="d-flex align-items-center bot-card-header h-100">
          <div className="flex-grow-1">
            <PlusCircle size="6rem" className="mb-2" />
            <h3 className="mb-2 text-truncate-2">{t("Blank bot")}</h3>
          </div>
        </div>
      </Card.Body>
      <hr className="m-0" />
      <Card.Body className="p-0">
        <Row xs="auto" className="bot-card-footer text-end justify-content-center" >
          {onWordpress && (
            <OverlayTrigger show={hover.state.wordpress} placement="bottom"
              overlay={<Tooltip>{t("Connect Wordpress")}</Tooltip>}
            >
              <Button variant="" className={className} {...hover.wordpress}
                onClick={async (e) => {
                  e.stopPropagation();
                  onWordpress();
                  await CONSOLE_EVENTS.EV_Wordpress.send({})
                }}
              >
                <img alt="Wordpress" src={wordpress} width="24" height="24" />
              </Button>
            </OverlayTrigger>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

const useHoverState = () => {
  const [state, setState] = useState({});
  const hoverSome = useCallback(
    (key) => ({
      onMouseEnter: () => setState({ [key]: true }),
      onMouseLeave: () => setState({ [key]: false }),
      onMouseDown: (event) => {
        event.preventDefault();
        setState({ [key]: false });
      },
    }),
    [setState]
  );
  return {
    state,
    body: hoverSome.bind(null, "body")(),
    wordpress: hoverSome.bind(null, "wordpress")(),
  };
};

export default BotNewCard;
